export default function selectRow(history, resource, id) {
  const { push, replace } = history;
  const href = `/${resource}/${id}`;

  replace({ ...location, state: { resourceId: id } });
  push(href);
}
